<template>
  <Grid ref="parentGrid" v-bind="{ ...props }" @add-button-clicked="addClick" @edit-button-clicked="editClick">
    <FluidBrandAddEditForm ref="addEditRef" @submit-add-edit-form="onFormSubmit" :isEditMode="isEditMode" />
  </Grid>
</template>

<script>
import Constants from '../../constants/constants';
import Grid from '../shared/Grid.vue';
import FluidBrandAddEditForm from './FluidBrandAddEditForm';
import FormMixin from '../shared/FormMixin';
import AjaxDataService from 'services/ajax.service';
import Endpoint from '../../constants/api/endpoint/fluid-brand.endpoint.constants';

export default {
  name: 'FluidBrandGrid',
  data() {
    return {
      props: {
        api: { ...Constants.Api.Endpoint.FluidBrand },
        columns: Constants.Grid.FluidBrand.columns,
        doClientSide: Constants.Grid.FluidBrand.doClientSide,
        filter: Constants.Grid.FluidBrand.filter,
        paging: Constants.Grid.FluidBrand.paging,
        searchHeader: Constants.Grid.FluidBrand.searchHeader,
        searchPlaceholder: Constants.Grid.FluidBrand.searchPlaceholder,
        sort: Constants.Grid.FluidBrand.sort,
        title: Constants.Grid.FluidBrand.title
      },
      columnConstants: Constants.ColumnName.FluidBrand,
      idField: Constants.ColumnName.FluidBrand.fluidBrandID.field,
      isEditMode: false,
      deletePrecheck: Endpoint.deletePrecheck
    };
  },
  mixins: [FormMixin],
  components: {
    Grid,
    FluidBrandAddEditForm
  },
  methods: {
    addClick() {
      this.isEditMode = false;
      this.$refs.addEditRef.openDialog({ isActive: true, isDeleted: false, editMode: false });
    },
    editClick(row) {
      this.isEditMode = true;
      this.$refs.addEditRef.openDialog({ ...row, editMode: true });
    },
    onFormSubmit(formData, _, isDelete, resolve) {
      // eslint-disable-next-line
      delete formData.modifiedOn;
      this.clearBlankLookupIDs(formData);
      if (this.isEditMode) {
        if (isDelete) {
          const params = { id: formData.fluidBrandID };
          AjaxDataService.getData(this.props.api.deletePrecheck, params).then(response => {
            if (response?.data?.count > 0) {
              resolve([
                `This item cannot be deleted. There are ${JSON.stringify(response.data.description)} related items.`
              ]);
              // eslint-disable-next-line no-alert
            } else if (window.confirm('Are you sure you want to delete this item?')) {
              AjaxDataService.deleteData(this.props.api.data, params);
              window.location.reload();
              resolve([]);
            } else {
              resolve([]);
            }
          });
        } else {
          AjaxDataService.postData(this.props.api.create, formData).then(() => {
            this.$nextTick(() => {
              this.$refs.parentGrid.loadData(true);
            });
          });
          resolve([]);
        }
      } else {
        AjaxDataService.postData(this.props.api.create, formData);
        resolve([]);
      }
    }
  }
};
</script>

